<template>
    <div class="bread">
        <!-- 柱状图表格 -->
        <template v-if="tableData.length>0">
            <div id="columnarChart"
                 ref="columnar"
                 class="columnarChart"
                 :style="{width: isMobile ? '355px' : '100%', height: isMobile ? (h + 'px') : '100%'}"></div>
        </template>

        <template v-if="tableData.length === 0">
            <div class="nodata">
                <span>暂无数据</span>
            </div>
        </template>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import macaronsDatas from './json/echartColor.json'
import {chartParse, colorData} from './js/color.js';
let chartsModel = "";
// var curInt = null;


export default {
    name: 'timeLine',
    props: {
      h: Number,
        //- 分组字段数据
        row: {
            type: Array,
            default: ()=>[]
        },
        //- 汇总字段数据
        summary: {
            type: Array,
            default: ()=>[]
        },
        //- drage组件大小修改后，饼图实时更新
        changeSize: {
            type: Number,
            default: 0
        },
        //- 表格数据
        tableData: {
            type: Array,
            default: ()=>[]
        },
        //- 表id
        id: {
            type: Number,
            default: 0
        },
        //- isFrontEnd是否为前端或者后端展示:true为后端,false为前端
        isFrontEnd: {
            type: Boolean,
            default: ()=>false
        },
        viewShow: {
            type: Boolean,
            default: ()=>false
        },
        selectIndex: {
            type: Number,
            default: ()=>null
        },
        user: {
            type: Array,
            default: () => []
        },
        width: [String, Number],
        isMobile: {
          type: Boolean,
          default: false
        },
        theme: Object,
        column: {
          type: Array,
          default: () => []
        }
    },
    data: function () {
        return {
            myChart: '',
            nameArray: [],

        }
    },
    mounted() {
        console.log("this.selectIndex==>",this.selectIndex);
        // if(this.selectIndex){
        //     curInt = this.selectIndex;
        // }
        this.$nextTick(()=>{
            this.openFunBread();
        })

    },
    methods: {
        updateFun(){
            console.log("更新");
          if (this.myChart.resize) this.myChart.resize();

        },
        //- 打开图表
        openFunBread(){
            console.log("openFun",this.tableData.length);
            if(this.tableData.length <= 25 && this.tableData.length > 0){
                this.$nextTick(()=>{
                    this.initData();
                })

            }

        },
      // series 值动态计算
      getSeries () {
        const series = []
        for (let s = 0; s < this.summary.length; s++) {
          const i = this.summary[s]
          const arr = this.tableData.map(its => its[i.title])
          if (this.theme && this.theme.axes) {
            series.push({
              data: arr,
              type: 'bar',
              barMaxWidth: 20, // 最大宽度
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#666666'
                  }
                }
              },
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
              },
              // 最大值气泡效果
              markPoint: {
                data: [{type:"max", name: ''}]
              }
            })
          } else {
            series.push({
              data: arr,
              type: 'bar',
              barMaxWidth: 20, // 最大宽度
              label: {
                normal: {
                  show: true,
                  position: 'top',
                  textStyle: {
                    color: '#666666'
                  }
                }
              },
              itemStyle: {
                normal: {
                  barBorderRadius: 5,
                  color: function () {
                    return colorData(s)
                  }
                },
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                },
              }
            })
          }
        }
        return series
      },
        //- 创建图表
        initData() {
            const that = this;
            let nameArray = []
          if (this.column && this.column.length > 0) {
            for (const i of this.tableData) {
              if (Array.isArray(i)) {
                for (const s of i) {
                  if (s) nameArray.push(s.name)
                }
              }
            }
            console.log('去重之前x轴数据', JSON.stringify(nameArray))
            nameArray = Array.from(new Set(nameArray))
          } else {
            nameArray = this.tableData.map(val=>{
              return val.name
            })
          }
          console.log('x轴数据', nameArray)

          chartsModel = "";
            // that.tableData[0].selected = true;
          this.$nextTick(()=>{
                 // 基于准备好的dom，初始化echarts实例
                let dom = that.$refs.columnar;
                if (!dom) return
                echarts.registerTheme('macarons', macaronsDatas.theme)
                chartsModel = echarts.init(dom,'macarons');

              const config =  {
                type: 'bar',
                barMaxWidth: 20, // 最大宽度
                label: {
                  normal: {
                    show: true,
                    position: 'top',
                    textStyle: {
                      color: '#666666'
                    }
                  }
                },
                itemStyle: {
                  normal: {
                    barBorderRadius: 5,
                    color: '#333'
                  },
                  emphasis: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                  },
                }
              }

              let seriesData = this.column.length > 0 ? chartParse({
                        date: this.tableData, column: this.column, summary: this.summary, xAxisData: nameArray, config: config, colorFu: this.theme && this.theme.axes ? this.theme.color : colorData, type: 'timeline'
                      }) : this.getSeries();
              let seriesLastData = seriesData[seriesData.length - 1].data;

              let barData = [
                {
                  name: '',
                  type: 'pie',
                  center: ['35%', '35%'],
                  radius: '28%',
                  // color: this.theme.color,
                  z: 100,
                  // 描边粗细、颜色
                  itemStyle: {
                    color: function (param) {
                      return colorData(param.dataIndex)
                    }
                    // borderWidth: this.theme.borderWidth,
                    // borderColor: this.theme.borderColor
                  },
                }
              ]
              if (this.theme && this.theme.axes) {
                delete barData[0].itemStyle.color
                barData[0].clor = this.theme.color
              }
              for(let i = 0; i < seriesLastData.length; i++){
                barData.push(seriesLastData[i])
              }
              let option = {

                  baseOption: {
                    timeline: {
                      show: false,
                      axisType: 'category',
                      autoPlay: false,
                      data: [''],
                    },
                    tooltip: {
                      trigger: 'axis',
                      backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
                      textStyle: {
                        color: "#333",
                      },
                      axisPointer: {
                      type: 'line',
                      label: {
                        backgroundColor: '#6a7985'
                      },
                      lineStyle: {
                        type: 'dashed',
                        // color: this.theme.tooltipAxisColor,
                        // width: this.theme.tooltipAxisWidth
                      }
                    }
                    },
                    legend: {
                      type: 'scroll',
                      top: '0',
                      left: 'right',
                      // data: ['第一产业', '第二产业', '第三产业'],
                      textStyle:{
                        // color: this.theme.legendTextColor
                      }
                    },
                    calculable: true,
                    grid: {
                      top: 80,
                      bottom: 40,
                      tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                          type: 'shadow',
                          label: {
                            show: true,
                          }
                        }
                      }
                    },
                    xAxis: [
                      {
                        type: 'category',
                        boundaryGap: true,
                        data: nameArray,
                        axisLabel: {
                          interval: 0,
                          color: '#666666',
                          formatter: function(val) {
                            return typeof val === 'string' && val ? val.split(/\1{1}/g).join('') : val
                          }
                        },
                        // 刻度设置
                        axisTick: {
                          show: true,
                          alignWithLabel: true
                        },
                        splitLine: {show: false},
                        axisLine: {
                          show: true,
                          lineStyle: {
                            color: '#D8D8D8'
                          }
                        },
                      }
                    ],
                    yAxis: [
                      {
                        type: 'value',
                        axisLabel: {
                          color: '#666666'
                        },
                        // 刻度设置
                        axisTick: {
                          show: true,
                          alignWithLabel: true
                        },
                        axisLine: {
                          show: true,
                          lineStyle: {
                            color: '#D8D8D8'
                          }
                        },
                        splitLine: {
                          show: false,
                        }
                      }
                    ],
                    series: barData
                  },
                  options: [
                    {
                      // 柱状颜色
                      series: seriesData
                    }
                  ]
                };
              if (this.theme && this.theme.axes) {
                const axisIndex = this.theme.axes.findIndex(its => its.type === 'category')
                const axis = this.theme.axes[axisIndex]
                console.log('x轴数据', nameArray, axis, axisIndex, this.theme.axes)

                option.baseOption.color = this.theme.color
                option.baseOption.tooltip = {
                  trigger: 'axis',
                  backgroundColor: "rgba(255,255,255,0.95)", //设置背景图片 rgba格式
                  textStyle: {
                    color: "#333",
                  },
                  axisPointer: {
                    type: 'cross',
                    label: {
                      backgroundColor: '#6a7985'
                    }
                  }
                }
                option.baseOption.series.color = this.theme.color
                option.options.color = this.theme.color


              }

            console.log('柱状图配置', option)
              chartsModel.clear();
                // 绘制图表
                chartsModel.setOption(option);
                chartsModel.off("click");
                chartsModel.on("click", (param)=>{
                    //- 设置柱状图点击事件
                    if(that.isFrontEnd === true){
                        return;
                    }
                    console.log("柱状图点击事件=====>",param);


                    that.relevanceFun(param.name,param.value,param.dataIndex);
                });
                that.myChart = chartsModel;
                that.$forceUpdate();
            })
        },
        //- 饼图点击事件，在客户端时候需要筛选查询该表单设置的对应关联表单
        relevanceFun(name,val,index){
            if(this.isFrontEnd === true){
                return;
            }
            let rowName = this.row[0].name;
            let summaryName = this.summary[0].name;
            let array = {};
            const nameArr = name ? name.split(/\1{1}/g) : name;
            if (Array.isArray(nameArr)) {
              for (let i = 0; i < this.row.length; i++) {
                array[this.row[i].name] = nameArr[i]
              }
            } else {
              array[rowName] = nameArr;
            }
            array[summaryName] = val;
            let date = {
                id: this.id,
                value: array,
                selectIndex: index
            }
            if (this.user[index]) date.user = this.user[index]
            this.$emit("relevanceFun",date)
        }
    },
    watch: {
        changeSize(val) {
            console.log("w===>",val)
            if(this.tableData.length>0){
                setTimeout(() => {
                    this.updateFun();

                }, 1000);

            }

        },
        'tableData':{
            handler (newV) {
                // do something, 可使用this
                console.log(newV)
                if(newV && newV.length>0){
                    this.$nextTick(()=>{
                        this.$forceUpdate();
                        this.openFunBread();
                    })
                }

            },
            deep:true

        },
        'selectIndex': {
            handler(newName) {

                console.log("变话了",newName)
                this.$nextTick(()=>{
                    this.$forceUpdate();
                    this.initData();
                })
            },
            deep:true
        },
        viewShow: {
          immediate: true,
          handler () {
            this.updateFun()
          }
        },
      width: {
        immediate: true,
        handler () {
          this.updateFun()
        }
      },
      theme: {
        immediate: true,
        deep: true,
        handler () {
          console.log('配置更新')
          this.initData();
        }
      },
    }
}
</script>

<style scoped lang="scss">
.bread {
    width: 100%;
    height: 100%;
    position: relative;

}
.nodata {
    width: 100%;
    text-align: center;
    color: #666666;
    line-height: 244px;
    height: 100%;
    position: relative;
    span{
        display: inline-block;
        position: absolute;
        top: 50%;
        -webkit-transform: translateY(-50%);
        transform: translateY(-50%);
        margin-left: -29px;

    }
}

</style>
